import React from 'react'
import AdminLogin from '../../components/AdminLogin/AdminLogin'

function AdminLoginPage() {
  return (
    <AdminLogin />
  )
}

export default AdminLoginPage